export default __webpack_public_path__ + "static/media/videoThumbnail.6c7c8cff.png";